import { EnvironmentProviders, makeEnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';
import { AuthorizationService } from '@core/authorization/services/authorization.service';

export const provideUserInfoEnvironment = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = loadUserInfoFactory(inject(UserInfoFacade), inject(AuthorizationService));
      return initializerFn();
    }),
  ]);

function loadUserInfoFactory(userInfoFacade: UserInfoFacade, authorizationService: AuthorizationService): () => void {
  return () => {
    if (!authorizationService.isAuthorized() || authorizationService.isRefreshTokenExpired) {
      authorizationService.logOut();
      return;
    }

    userInfoFacade.loadUserInfo();
  };
}
